import { FC } from 'react';

import { Experiment } from 'components/experiment';
import { RunningExperiments } from 'state/experiments';

import LoyaltyRewards from './loyalty-rewards';
import LoyaltyRewardsRedesign from './loyalty-rewards-redesign';
import { ILoyaltyRewardsProps } from './types';

/**
 * Temporary wrapper to control which version of the loyalty rewards page to display while
 * the Rewards Page redesign experiment is running.
 */

const LoyaltyRewardsWrapper: FC<React.PropsWithChildren<ILoyaltyRewardsProps>> = props => {
  return (
    <Experiment
      flag={RunningExperiments.RewardsPageRedesignPhaseOne}
      control={<LoyaltyRewards {...props} />}
      treatment={<LoyaltyRewardsRedesign {...props} />}
    />
  );
};

export default LoyaltyRewardsWrapper;
